<section class="flex justify-content-center wrapper mb-5 mt-4">
  <div class="wrapper-content flex-column xl:flex-row">
    <div class="app-card h-full col-12 px-0">
      <CustomTitle [title]="titulo"
                   styleClass="font-principal color-form-label font-medium font-23 text-uppercase mt-3 ml-6 "/>
      <p-divider class="px-6"/>
      <app-buscar-sisben 
        (sisben)="getSearchValues($event)" 
        (clearSearch)="clearSearch()"
        [tiposIdentificaciones]="tiposIdentificaciones"/>
      <p-divider class="px-6"/>
      <app-informacion-sisben
        [eliminar]="isEliminacion" [modificar]="isModificacion"
        (deleteEmitter)="handlerDelete($event)"
        (editEmitter)="handlerEdit($event)"/>
      <p-divider class="px-6"/>
      <app-form-viewer [onSubmitForm]="onSubmitForm"></app-form-viewer>
    </div>
  </div>
</section>

<app-procesar-tramite></app-procesar-tramite>
